import { getFullErrorState } from '../general/selectors';

import { LeadsBenchmarkYearlyOverviewActionTypes } from './constants';
import { getLeadsBenchmarkYearlyOverviewCacheDictionaryKey } from './selectors';

export const yearlyOverview = (state, action) => {
  switch (action.type) {
    case LeadsBenchmarkYearlyOverviewActionTypes.GET_YEARLY_OVERVIEW_DATA_LOADING:
      return {
        ...state,
        yearChartLoading: true,
      };
    case LeadsBenchmarkYearlyOverviewActionTypes.GET_YEARLY_OVERVIEW_DATA_SUCCESS:
      return {
        ...state,
        // caching to avoid unnecessary ajax calls
        [getLeadsBenchmarkYearlyOverviewCacheDictionaryKey(
          state.selectedYear,
          action.currentLevel,
          action.currentDealerId,
        )]: action.result,
        yearChartLoading: false,
      };
    case LeadsBenchmarkYearlyOverviewActionTypes.GET_YEARLY_OVERVIEW_DATA_CANCELLED:
      return {
        ...state,
        yearChartLoading: false,
      };
    case LeadsBenchmarkYearlyOverviewActionTypes.GET_YEARLY_OVERVIEW_DATA_ERROR:
      return {
        ...getFullErrorState(state, action),
        yearChartLoading: false,
      };
    default:
      return state;
  }
};
